<template>
  <LayoutAppContent
    ><div class="h-full overflow-auto" :class="$style['landing-background']">
      <PublicLandingHeader title="Connect" subtitle="Hawaii State Environmental Health Administration" light>
        <template #logo>
          <LogoConnect class="" backgroundColor="#fff" foregroundColor="#000" />
        </template>
      </PublicLandingHeader>
      <PublicLandingAlerts :items="publicLandingAlertsitems" />
      <PublicLandingContainer class="grid xl:grid-cols-2 2xl:grid-cols-5 3xl:grid-cols-3 justify-start">
        <!-- <div
      class="lg:container mx-auto md:px-8 grid xl:grid-cols-2 2xl:grid-cols-5 3xl:grid-cols-3 gap-16 mt-5 md:mt-10 justify-start"
    > -->
        <PublicLandingBackdrop light class="xl:col-span-2 2xl:col-span-5 3xl:col-span-3">
          <div class="grid grid-cols-1 gap-10">
            <!-- 2xl:grid-cols-2 -->
            <div class="2xl:col-span-2 bg-white/90 shadow md:rounded-xl" v-if="false">
              <div class="justify-between px-4 py-5 sm:p-10 2xl:flex">
                <div>
                  <div class="text-2xl">Online Services</div>
                  <h2 class="mt-2 text-xl text-sky-500 md:mt-1">
                    <span class="font-semibold"><LoginButton class="hover:underline" /></span>
                    or
                    <RegisterButton class="cursor-pointer font-semibold hover:underline">Register</RegisterButton>
                    to get started
                  </h2>
                  <p class="text-base text-neutral-600 mt-3 mb-3">
                    The Air Quality Management System (AQMS) offers online access to Division of Air Quality services.
                  </p>
                </div>
                <div class="mt-10 space-y-2 flex justify-stretch flex-col w-full 2xl:mt-0 2xl:w-72 2xl:ml-10">
                  <LoginButton :as="BaseButton" variant="priority-hollow" class="w-full sm:w-auto" label="Sign In" />
                  <div class="flex relative px-2">
                    <div class="flex-1" aria-hidden="true">
                      <div class="w-full border-t border-gray-300 relative top-3 -mt-px">&nbsp;</div>
                    </div>
                    <div class="px-2 flex-none text-sm text-gray-500">or</div>
                    <div class="flex-1" aria-hidden="true">
                      <div class="w-full border-t border-gray-300 relative top-3 -mt-px">&nbsp;</div>
                    </div>
                  </div>

                  <RegisterButton :as="BaseButton" variant="priority" class="w-full sm:w-auto" label="Register" />
                </div>
              </div>
            </div>
            <PublicLandingOnlineServices hideActions title="Keeping you connected to your local environment" class="">
              <!-- 2xl:col-span-2 -->
              <template #body>
                <p>
                  Connect provides access to environmental data from the Hawaiian Islands. Select an environmental
                  interest below to get started.
                </p>
                <!-- <p class="mt-2"><BaseButton variant="link" label="Explore the Data" :to="{ name: '' }" /></p> -->
                <!-- class="w-full lg:w-2/3 text-xl" -->
              </template>
            </PublicLandingOnlineServices>

            <PublicLandingLinkCards>
              <PublicLandingLinkCard
                v-for="dataset in viewerStore.datasetMetadata"
                :to="{ name: mapRouteName, query: { ds: dataset.id } }"
                :title="dataset.label"
                :description="dataset.description || ''"
              >
                <template #icon>
                  <PinIcon
                    class="rounded-full bg-neutral-400 inline-flex items-center justify-center h-9 w-9 transition-all group-focus:scale-110 group-focus:bg-neutral-300 group-hover:scale-110 group-hover:bg-neutral-300"
                    :viewer-color="(dataset as ViewerDataset).datasetGroup.colors"
                  />
                </template>
              </PublicLandingLinkCard>
              <!-- <PublicLandingLinkCard
                :to="{ name: mapRouteName }"
                title="All Data"
                description="Explore all Connect environmental data on the map without preset filters."
              >
                <template #icon>
                  <PinIcon
                    class="rounded-full bg-neutral-400 inline-flex items-center justify-center h-9 w-9 transition-all group-focus:scale-110 group-focus:bg-neutral-300 group-hover:scale-110 group-hover:bg-neutral-300"
                    :viewer-color="{
                      foreground: 'rgb(0,0,0)',
                      background: 'rgb(255,255,255)',
                      fill: 'rgba(255,127,0,.2)',
                      isDarkForeground: true,
                    }"
                  />
                </template>
              </PublicLandingLinkCard> -->
            </PublicLandingLinkCards>
          </div>
        </PublicLandingBackdrop>
      </PublicLandingContainer>
      <PublicLandingAlerts
        variant="warn"
        title="Please be advised that the map viewer is a piloted feature."
        description="<p>We will continue to enhance functionality and improve data quality as resources become available. If you have any questions, please contact <a href='mailto:epwebadmin@doh.hawaii.gov' class='hover:underline'>epwebadmin@doh.hawaii.gov</a>.</p>"
      />
      <MdrnFooter light black-and-white />
    </div>
  </LayoutAppContent>

  <LayoutAppContent v-if="false">
    <div class="h-full overflow-auto bg-neutral-100">
      <div class="">
        <!-- content -->
        <div class="p-5 sm:pt-10 bg-neutral-800">
          <div
            class="flex justify-items-stretch justify-between mt-4 mb-6 flex-wrap w-full sm:w-3/4 mx-auto 2xl:w-3/4 4xl:w-1/2 xl:flex-nowrap"
          >
            <div class="xl:w-5/12">
              <div
                class="text-3xl rounded-t-xl bg-white px-5 pb-2 pt-2.5 w-max"
                style="color: rgb(93, 240, 246); font-weight: 400"
              >
                EHA<span style="color: rgb(12, 79, 90); font-weight: 700">CONNECT</span>
              </div>
              <h1 class="relative inline-block w-full text-left">
                <span class="mt-4 block text-2xl md:text-5xl md:leading-snug font-medium text-neutral-100"
                  >Keeping you connected to your local environment</span
                >
              </h1>
              <h2 class="mt-4 text-lg md:text-2xl text-neutral-300">
                Hawaii State Environmental Health Administration
              </h2>
              <p class="text-base md:text-lg mt-4 text-neutral-300">
                Connect provides access to environmental data from the Hawaiian Islands
              </p>
            </div>
            <div class="w-full xl:w-1/2 mt-6 xl:mt-0 text-center">
              <SimpleMap class="h-96 w-full bg-neutral-800" :topo-json="hiTopoJson" />
              <BaseButton
                variant="priority"
                class="w-full lg:w-2/3 text-xl"
                label="Explore the Data"
                @click="$router.push({ name: mapRouteName })"
              />
            </div>

            <!-- <div class="hidden">
              <FormKit
                type="search"
                label="search"
                name="keyword"
                placeholder="search all of our data - try 'emission'"
                :sections-schema="noLabel"
                inner-class="bg-white"
                outer-class="!mb-0"
                input-class="py-3"
                @keydown.enter="keywordSearch($event)"
              ></FormKit>
            </div> -->
          </div>
        </div>

        <div class="px-2 sm:px-0 mt-10 mx-auto w-full sm:w-3/4 2xl:w-3/4 4xl:w-1/2">
          <h2 class="text-2xl font-medium text-neutral-700 text-center">Filter by Environmental Interest</h2>
          <div>{{ viewerStore.datasetMetadata }}</div>
          <ul role="list" class="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
            <li class="col-span-1 flex rounded-md shadow-sm" v-for="dataset in viewerStore.datasetMetadata">
              <router-link
                :to="{ name: mapRouteName, query: { ds: (dataset as ViewerDataset).id } }"
                class="group w-full rounded-md border border-neutral-200 bg-white p-1 text-neutral-900 transition-all hover:border-sky-200 hover:bg-sky-100 focus:border-sky-200 focus:bg-sky-100"
              >
                <div class="flex flex-1 items-center justify-between pl-4 pr-1 pt-2 pb-1">
                  <div class="flex-1 pr-4 text-base group-hover:text-sky-900 group-focus:text-sky-900">
                    <div class="font-medium">{{ (dataset as ViewerDataset).label }}</div>
                  </div>
                  <PinIcon
                    class="rounded-full bg-neutral-300 mr-3 flex-none inline-flex items-center justify-center h-9 w-9 transition-transform group-hover:scale-110"
                    :viewer-color="(dataset as ViewerDataset).datasetGroup.colors"
                  />
                </div>
                <div class="flex-1 space-y-0.5 px-4 py-2 text-sm empty:py-0">
                  {{ dataset.description }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="px-2 sm:px-0 mt-20 mx-auto w-full sm:w-3/4 2xl:w-3/4 4xl:w-1/2">
          <div class="sm:flex sm:items-start border border-neutral-200 rounded-md shadow-sm bg-yellow-100 p-3">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 bg-yellow-200"
            >
              <ExclamationCircleIcon class="h-6 w-6 text-yellow-600" aria-hidden="true" />
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 class="text-base font-medium leading-6 text-gray-900">
                Please be advised that the map viewer is a piloted feature.
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  We will continue to enhance functionality and improve data quality as resources become available. If
                  you have any questions, please contact
                  <a href="mailto:epwebadmin@doh.hawaii.gov">epwebadmin@doh.hawaii.gov</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="sticky top-[100vh] mt-20 flex h-10 flex-col items-center p-2">
        <MdrnAttribution />
      </footer>
    </div>
  </LayoutAppContent>
</template>

<script lang="ts">
import { SimpleMap } from "@modernary/mui/components/simpleMap";
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import {
  MdrnAttribution,
  MdrnFooter,
  NoneFoundFlag,
  SkeletonButton,
  useAppNav,
} from "@modernary/mui/components/common";
import { useUser } from "@modernary/mui/utils/authentication";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { useAuthorization } from "@modernary/mui/utils/authorization";
import { noLabelSchema } from "@modernary/mui/utils/helpers";
import {
  PublicLandingAlerts,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingParagraph,
  PublicLandingHeader,
  PublicLandingOnlineServices,
  PublicLandingLinkCard,
  PublicLandingLinkCards,
  PublicLandingBackdrop,
  PublicLandingContainer,
} from "@modernary/mui/components/publicLanding";

import { LayoutAppContent } from "@modernary/mui/components/layouts";
import { ref, computed, watch, defineComponent } from "vue";
import { FaceSmileIcon, PlusIcon } from "@heroicons/vue/24/solid";
import { ChevronRightIcon, ExclamationCircleIcon } from "@heroicons/vue/24/outline";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/vue/20/solid";
import { useViewerStore, PinIcon, type ViewerDataset } from "@modernary/mui/components/viewer";
import { additionalMetadata, metadataContext } from "./map/mapSettings";
import { useRouter } from "vue-router";
import { mapRouteNames } from "./map/mapRoutes";
import hiTopoJson from "@/constants/hawaii-counties-topo.json";
import LogoConnect from "@/components/LogoConnect.vue";

export default defineComponent({
  components: {
    SkeletonButton,
    BaseButton,
    InitialBadge,
    PlusIcon,
    ChevronRightIcon,
    MdrnAttribution,
    FaceSmileIcon,
    NoneFoundFlag,
    PhoneIcon,
    EnvelopeIcon,
    SimpleMap,
    PinIcon,
    ExclamationCircleIcon,
    LogoConnect,
    PublicLandingAlerts,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingHeader,
    PublicLandingOnlineServices,
    PublicLandingLinkCard,
    PublicLandingLinkCards,
    PublicLandingBackdrop,
    PublicLandingContainer,
    MdrnFooter,
    LayoutAppContent,
    RegisterButton,
    LoginButton,
    LogoutButton,
  },
  setup() {
    // TODO: Fix the TS issues in the template with the metadata.
    const viewerStore = useViewerStore();
    const { userRef } = useUser();
    const router = useRouter();
    const noLabel = noLabelSchema();

    const { authorizationClient, AuthRequest, handlePreempts } = useAuthorization();

    // viewerStore.additionalMetadata = additionalMetadata;
    viewerStore.metadataContext = metadataContext;
    viewerStore.hydrateDatasetMetadata();

    const keywordSearch = ($event: KeyboardEvent) => {
      router.push({ name: mapRouteNames.map, query: { keywords: ($event.target as HTMLInputElement).value } });
    };

    const publicLandingAlertsitems = ref([
      // {
      //   title: "Please be advised that the map viewer is a piloted feature.",
      //   description: "We will continue to enhance functionality and improve data quality as resources become available. If you have any questions, please contact epwebadmin@doh.hawaii.gov.",
      // },
    ]);

    return {
      hiTopoJson,
      keywordSearch,
      noLabel,
      userRef,
      BaseButton,
      viewerStore,
      mapRouteName: mapRouteNames.map,
      publicLandingAlertsitems,
    };
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #0c0f28; /* average color from the bg */
  background-image: url("/images/backgrounds/hi.jpg");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
